var scope_0 = require('/home/runner/work/integrate-institute/integrate-institute/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/26f0288724c144d13d85233e9b1f5602.js').default;
var scope_1 = require('/home/runner/work/integrate-institute/integrate-institute/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/863e0310165c7c983e368c28bbaee86e.js').default;
var scope_2 = require('/home/runner/work/integrate-institute/integrate-institute/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    